<app-nav></app-nav>
<div class="page-body-config" role="main">
  <ng-container *ngIf="dogRemoved">
    <header>
      <h1 class="page-header">Confirm Removal</h1>
    </header>
    <div class="body-container mx-auto">
      <app-dog-removed-survey
        [petId]="petId"
        [petName]="petName"
      ></app-dog-removed-survey>
    </div>
  </ng-container>
  <ng-container *ngIf="!dogRemoved">
    <header>
      <h1 class="page-header">Camper Profile</h1>
    </header>
    <div id="main-content">
      <div class="dog-profile-card">
        <div>
          <img
            class="pet-avatar"
            [src]="localProfileIcon"
            alt="Profile Picture"
          />
        </div>
        <div class="text-container">
          <h5 class="title oswald crimson">{{ this.petName }}</h5>
        </div>
      </div>
      <mat-tab-group
        #tabs
        class="left-stepper"
        [disableRipple]="true"
        [@.disabled]="true"
        [(selectedIndex)]="currIndex"
      >
        <mat-tab label="Camper Details">
          <div class="inner-content">
            <div class="content mx-auto">
              <app-camper-details
                #cdPage
                [petId]="petId"
                (petNameChange)="handlePetNameChange($event)"
                (dogRemoved)="handleDogRemoved()"
              ></app-camper-details>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Health Records">
          <div class="inner-content">
            <div class="content mx-auto">
              <app-health-records #hrPage [petId]="petId"></app-health-records>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Diet + Meds">
          <div class="inner-content">
            <div class="content mx-auto">
              <app-diet-meds #dmPage [petId]="petId"></app-diet-meds>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>
</div>
<app-footer></app-footer>
